var image_upload_default = {
  "container": "PjHPe",
  "disabled": "ePprz",
  "imageInput": "JFl0F",
  "overlay": "gfZ20",
  "text": "xCTkm",
  "shown": "dDEHl",
  "hide": "Rm7hw",
  "spinner": "-mij4",
  "spin": "_2nY-u"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
